import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DropdownItem } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

const MainNavBarLogoutLink: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { isOfflineModeEnabled } = rootStore.commonStore;
  const { nativeAppConf, offlineLogout } = rootStore.offlineStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  return (
    <>
      {isOfflineModeEnabled ? (
        <>
          {nativeAppConf && nativeAppConf.requirePin ? (
            <DropdownItem onClick={() =>  offlineLogout()}>
              {t("navbar_dropdown_logout")}
            </DropdownItem>
          ) : (<></>)}
        </>
      ) : (
        <DropdownItem tag={Link} to={"/logout"}>
        {t("navbar_dropdown_logout")}
      </DropdownItem>

      )}
    </>
  );
};

export default observer(MainNavBarLogoutLink);
